import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useContactContext } from "../../shared/context/ContactContext";
import "./contact.css";

const EMPTY_FORM = { name: "", email: "", subject: "", text: "" };

export default function ContactForm() {
  const { SendForm } = useContactContext();
  const { t } = useTranslation();
  const [form, setForm] = useState(EMPTY_FORM);
  // idle | sending | success | error
  const [status, setStatus] = useState("idle");

  function update(field) {
    return (e) => setForm({ ...form, [field]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("sending");
    const response = await SendForm(form);
    if (response?.data?.status === "success") {
      setStatus("success");
      setForm(EMPTY_FORM);
    } else {
      setStatus("error");
    }
  }

  return (
    <form className="avc-contact-form" onSubmit={handleSubmit}>
      <h2 className="avc-contact-form__title">{t("contact_form_title")}</h2>

      {status === "success" && (
        <p className="avc-alert avc-alert--success" role="status">
          <i className="fas fa-check-circle" aria-hidden="true"></i>
          {t("contact_success")}
        </p>
      )}
      {status === "error" && (
        <p className="avc-alert avc-alert--error" role="alert">
          <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
          {t("contact_error")}
        </p>
      )}

      <div className="avc-contact-form__row">
        <label className="avc-field">
          <span className="avc-field__label">
            {t("Your_Name")} <span aria-hidden="true">*</span>
          </span>
          <input
            type="text"
            required
            autoComplete="name"
            value={form.name}
            onChange={update("name")}
          />
        </label>
        <label className="avc-field">
          <span className="avc-field__label">
            {t("Your_Email")} <span aria-hidden="true">*</span>
          </span>
          <input
            type="email"
            required
            autoComplete="email"
            dir="ltr"
            value={form.email}
            onChange={update("email")}
          />
        </label>
      </div>
      <label className="avc-field">
        <span className="avc-field__label">
          {t("Subject")} <span aria-hidden="true">*</span>
        </span>
        <input type="text" required value={form.subject} onChange={update("subject")} />
      </label>
      <label className="avc-field">
        <span className="avc-field__label">
          {t("Message")} <span aria-hidden="true">*</span>
        </span>
        <textarea required rows={6} value={form.text} onChange={update("text")} />
      </label>

      <button
        type="submit"
        className="avc-btn avc-btn--gold avc-contact-form__submit"
        disabled={status === "sending"}
      >
        <i className="far fa-paper-plane" aria-hidden="true"></i>
        {status === "sending" ? t("contact_sending") : t("Send_Message")}
      </button>
    </form>
  );
}
